import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "custom-class": "App-User-Profile-Modal App-Unpadded",
    "model-value": _ctx.isModalOpen,
    width: "550px",
    "show-close": true,
    onOpen: _ctx.opened,
    title: "Title",
    "txt-center": "",
    "close-on-click-modal": false,
    "append-to-body": true,
    "lock-scroll": true,
    "open-delay": 200,
    "close-delay": 200
  }, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", null, [
        _createVNode(_component_el_form, {
          onSubmit: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
          class: "App-Styled-Form",
          "label-position": 'top',
          "label-width": "100px",
          model: _ctx.form,
          style: {"margin-top":"12px"}
        }, null, 8, ["model"])
      ])), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _: 1
  }, 8, ["model-value", "onOpen"]))
}